// // src/pages/avsync/Handoff.js
// // AV Sync — Handoff & Maintenance Documentation
// import React from "react";
// import "../../App.css";

// export default function Handoff() {
//   return (
//     <div className="posts">
//       <h1>AV Sync — Handoff & Maintenance Documentation</h1>
//       <p className="intro-text">
//         This section includes all materials required for project handoff,
//         long-term maintenance, and future development extensions.
//       </p>

//       {/* HANDOFF PACKET */}
//       <div className="post-item">
//         <h2 className="post-title">Handoff Packet Contents</h2>
//         <ul className="post-pargrphs">
//           <li>Full source code (client + server)</li>
//           <li>Scanner Utility (macOS + Windows)</li>
//           <li>Architecture diagrams + data flow</li>
//           <li>Environment variable documentation</li>
//           <li>Deployment instructions (Render, Vercel, Firebase)</li>
//           <li>Backup + maintenance strategy</li>
//         </ul>
//       </div>

//       {/* MAINTENANCE */}
//       <div className="post-item">
//         <h2 className="post-title">Maintenance Overview</h2>
//         <ul className="post-pargrphs">
//           <li>How to update scanner utility</li>
//           <li>How to extend the API</li>
//           <li>How to add new device fields</li>
//           <li>How to modify Firebase auth behavior</li>
//         </ul>
//       </div>

//       {/* LINKS */}
//       <div className="post-item">
//         <h2 className="post-title">Related Pages</h2>
//         <ul className="post-pargrphs">
//           <li>
//             <a className="post-links" href="/avsync/scanner">
//               Scanner Utility Docs
//             </a>
//           </li>
//           <li>
//             <a className="post-links" href="/avsync/docs">
//               Documentation Hub
//             </a>
//           </li>
//           <li>
//             <a className="post-links" href="/avsync">
//               Back to AV Sync Page
//             </a>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// }
import React from "react";
import "../../App.css";

export default function Handoff() {
  return (
    <div className="posts">
      <h1>AV Sync — Final Handoff & Maintenance Documentation</h1>
      <p className="intro-text">
        This handoff packet contains everything needed to deploy, maintain, and
        continue development of the AV Sync project.
      </p>

      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title"> Repository Structure</h2>

        <pre className="code-block">{`
avsync/
│
├── avsync-expo-app/         > Frontend (React Native + Expo)
├── avsync-server/           > Backend (Node.js + Express)
└── scanner-utility/         > Local network scanner (Node-based)
        `}</pre>
      </div>

      {/* ------------------------------------------------------------- */}
      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title">GitHub Repositories</h2>

        <ul className="post-pargrphs">
          <li>
            <strong>Frontend (Expo App):</strong>{" "}
            <a
              className="post-links"
              href="https://github.com/VictoriaSavannah-FS/avsync-expo-app"
              target="_blank"
              rel="noopener noreferrer"
            >
              github.com/.../avsync-expo-app
            </a>
          </li>

          <li>
            <strong>Backend (Node + Express API):</strong>{" "}
            <a
              className="post-links"
              href="https://github.com/VictoriaSavannah-FS/avsync-server"
              target="_blank"
              rel="noopener noreferrer"
            >
              github.com/.../avsync-server
            </a>
          </li>

          <li>
            <strong>Local Scanner Utility:</strong>{" "}
            <a
              className="post-links"
              href="https://github.com/VictoriaSavannah-FS/avsync-scanner-public.git"
              target="_blank"
              rel="noopener noreferrer"
            >
              github.com/.../avsync-scanner-public
            </a>
          </li>
        </ul>
      </div>
      <div className="post-item">
        <h2 className="post-title">System Architecture Diagram</h2>

        <pre className="code-block">{`
           [ Local Scanner Utility ] 
                     │
                     ▼
              ( HTTPS POST )
                     │
                     ▼
      ┌─────────────────────────────────┐
      │      AV Sync Backend (API)      │
      │  Node.js + Express + Mongoose   │
      └─────────────────────────────────┘
                     │
                     ▼
                [ MongoDB ]
                     │
                     ▼
           [ AV Sync Web App / Mobile App ]
        `}</pre>
      </div>

      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title">API Flow (Scan → DB → Frontend)</h2>

        <pre className="code-block">{`
Local Scanner Utility
        │
        ├─> GET /devices?userId=uid     > fetch existing
        ├─> POST /devices               > each discovered device
        │
        ▼
MongoDB (devices collection)
        │
        ▼
AV Sync Frontend (fetches user's devices via Axios)
        `}</pre>
      </div>

      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title">Backend Setup</h2>

        <ol className="post-pargrphs">
          <li>
            Install dependencies:
            <pre className="code-block">npm install</pre>
          </li>
          <li>
            Configure <code>.env</code>:
            <ul>
              <li>MONGO_URI=…</li>
              <li>PORT=8080</li>
            </ul>
          </li>
          <li>
            Start server:
            <pre className="code-block">npm run dev</pre>
          </li>
        </ol>
      </div>

      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title">Frontend Setup (Expo)</h2>

        <ol className="post-pargrphs">
          <li>
            Install dependencies:
            <pre className="code-block">npm install</pre>
          </li>
          <li>
            Start the Expo app:
            <pre className="code-block">npx expo start</pre>
          </li>
        </ol>
      </div>

      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title">Scanner Utility Setup</h2>

        <p className="post-pargrphs">
          Full instructions available inside the{" "}
          <a href="/avsync/scanner" className="post-links">
            Scanner Documentation →
          </a>
        </p>
      </div>

      {/* ------------------------------------------------------------- */}
      <div className="post-item">
        <h2 className="post-title">🛠 Future Maintenance Recommendations</h2>

        <ul className="post-pargrphs">
          <li>Refactor frontend into a Design System</li>
          <li>Migrate backend to AWS or Vercel Serverless</li>
          <li>Add WebSocket support for real-time updates</li>
          <li>Replace mock data with scanner data by default</li>
          <li>Add admin dashboard for technician teams</li>
        </ul>
      </div>
      {/* Lincense --- */}
      <div className="post-item">
        <h2 className="post-title">License</h2>
        <p className="post-pargrphs">
          This project is open-source under the MIT License. All scanner,
          backend, and frontend components may be used or extended with
          attribution.
        </p>
      </div>
    </div>
  );
}
